import React, { ReactElement, useEffect, useState } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import styles from './index.scss';
import properties from '../../../../modules/ajio-util/properties';
import { showModal, hideModal } from '../../../../actions/shared/modal';
import ImageSlider from '../../../molecules/ImageSlider';
import ReviewDetails from '../ReviewDetails/ReviewDetails';

const cx = className.bind(styles);
const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config)),
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
const mapStateToProps = state => {
  const modals = state ? state.modals : {};
  const singlePhotoModal = modals?.['reviews-single-photo'] || {};
  const modalData = singlePhotoModal.state || {};
  return {
    modalData
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const ReviewSinglePhotoModal = ({ modalData, app, productDetails = {} }: {}): ReactElement => {
  const {
    reviewData,
    reviewsCollection,
    loop = false,
    clickIndex = 0,
    arrowEnabled = false,
    fromCustomerGridModal = false
  } = modalData;

  const [selectedImageIndex, setSelectedImageIndex] = useState(clickIndex);
  const [reviewsObj, setReviewsOBj] = useState(reviewData);
  const [backButton, setBackClick] = useState(false);

  const { imageMap } = reviewsObj;
  const { thumbnail } = imageMap;
  const imageArray = thumbnail.map(imageObject => imageObject.imageUrl);

  useEffect(() => {
    if (arrowEnabled) {
      let currentReviewdId = reviewsObj.reviewId;
      let nextReview = reviewsCollection.findIndex(e => {
        return e.reviewId === currentReviewdId;
      });
      if (!backButton && selectedImageIndex + 1 === imageArray.length + 1) {
        if (nextReview + 1 === reviewsCollection.length) {
          updateSelectedImageIndex(0);
          setReviewsOBj(reviewsCollection[0]);
        } else {
          updateSelectedImageIndex(0);
          setReviewsOBj(reviewsCollection[nextReview + 1]);
        }
      } else if (backButton && selectedImageIndex <= 0) {
        if (nextReview === 0) {
          let reviewObject = reviewsCollection[reviewsCollection.length - 1];
          let noOfImages = reviewObject?.imageMap?.thumbnail.length;
          updateSelectedImageIndex(noOfImages - 1);
          setReviewsOBj(reviewObject);
        } else {
          let reviewObject = reviewsCollection[nextReview - 1];
          let noOfImages = reviewObject?.imageMap?.thumbnail.length;
          updateSelectedImageIndex(noOfImages - 1);
          setReviewsOBj(reviewObject);
        }
      }
    }
  }, [selectedImageIndex]);

  const updateSelectedImageIndex = currentIndex => {
    setSelectedImageIndex(currentIndex);
  };
  const updateBackButtonClick = val => {
    setBackClick(val);
  };

  return (
    <>
      <div className={cx('single-photo-modal-web')}>
        <div className={cx('single-photo-modal-container-web')}>
          <div className={cx('image-slider-container')}>
            <ImageSlider
              currentIndex={selectedImageIndex}
              updateSelectedImageIndex={updateSelectedImageIndex}
              backwardButtonClick={updateBackButtonClick}
              isMobile={false}
              imageArray={imageArray}
              productDetails={productDetails}
              pageName="PDP"
              pageType="PDP"
              fromCustomerGridModal={fromCustomerGridModal}
              loop={loop}
            />
            <div className={cx('single-photo-modal-imageCount-web')}>
              <p className={cx('single-photo-modal-imageCount-number-web')}>
                {selectedImageIndex + 1} of {imageArray.length}
              </p>
            </div>
          </div>
          <div className={cx('single-photo-modal-text-container')}>
            <ReviewDetails
              isDesktop
              reviewData={reviewsObj}
              single
              currentIndex={selectedImageIndex}
              updateSelectedImageIndex={updateSelectedImageIndex}
              productDetails={productDetails}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default connector(ReviewSinglePhotoModal);
